import Router from './assets/aids/router/Router'

function App() {
  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;
